/*

1. Browse https://fontawesome.com/search?o=r&m=free&s=solid to find the icon you need.
2. Import the chosen icon here, and add it to the library.
3. Use the icon anywhere with packages/ui-components/src/icons/Icon.tsx component.

Custom icons uploaded to our fontawesome kit are available in the library as well. Use faPrefix="fak" to access them.

*/

import { fak } from "@awesome.me/kit-c7777e19bb/icons";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCcVisa } from "@fortawesome/free-brands-svg-icons";
import { faFrame } from "@fortawesome/pro-light-svg-icons";
import {
  faAlignCenter,
  faAlignJustify,
  faAlignLeft,
  faAlignRight,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faAngleUp,
  faAnglesDown,
  faAnglesUp,
  faArrowDownToLine,
  faArrowDownToSquare,
  faArrowLeftToLine,
  faArrowPointer,
  faArrowProgress,
  faArrowRight,
  faArrowRightArrowLeft,
  faArrowRightLong,
  faArrowRightToLine,
  faArrowRotateLeft,
  faArrowRotateRight,
  faArrowTurnUp,
  faArrowUp,
  faArrowUpRightAndArrowDownLeftFromCenter,
  faArrowUpToLine,
  faArrowsRotate,
  faBars,
  faBooks,
  faBorderAll,
  faBorderCenterH,
  faBorderCenterV,
  faBorderLeft,
  faBorderNone,
  faBorderTopLeft,
  faBox,
  faBoxOpen,
  faBroomWide,
  faBrowser,
  faBullhorn,
  faCalendarDays,
  faChain,
  faCheck,
  faCheckCircle,
  faCircle,
  faCircleNotch,
  faClipboard,
  faCodeBranch,
  faCog,
  faCommentsQuestion,
  faComputerMouse,
  faComputerMouseButtonLeft,
  faComputerMouseButtonRight,
  faComputerMouseScrollwheel,
  faCopy,
  faCube,
  faCubes,
  faDeleteLeft,
  faDolly,
  faDownload,
  faEllipsisH,
  faEllipsisV,
  faEllipsisVertical,
  faEnvelope,
  faEraser,
  faExclamationCircle,
  faEye,
  faEyeSlash,
  faFileAlt,
  faFileAudio,
  faFileImage,
  faFileLines,
  faFileVideo,
  faFilter,
  faFlag,
  faFolder,
  faFolderOpen,
  faGear,
  faGears,
  faGift,
  faGlasses,
  faGraduationCap,
  faHandPaper,
  faHeadset,
  faHistory,
  faHouse,
  faImage,
  faIndent,
  faInfoCircle,
  faKeyboard,
  faLanguage,
  faLayerGroup,
  faLightbulb,
  faLightbulbOn,
  faLink,
  faLock,
  faLockOpen,
  faMapPin,
  faMaximize,
  faMicrochip,
  faMinimize,
  faMinus,
  faMobileScreenButton,
  faMoon,
  faObjectGroup,
  faOutdent,
  faPalette,
  faPaperPlane,
  faPaste,
  faPenField,
  faPenToSquare,
  faPencilAlt,
  faPlay,
  faPlus,
  faQuestionCircle,
  faRectangleHistoryCirclePlus,
  faRedoAlt,
  faRetweet,
  faRightFromBracket,
  faRightLeft,
  faRotateLeft,
  faRotateRight,
  faSave,
  faScissors,
  faSearch,
  faShield,
  faSignInAlt,
  faSlidersH,
  faSpinner,
  faSpinnerThird,
  faSun,
  faSwatchbook,
  faSync,
  faTableCells,
  faTableColumns,
  faTag,
  faTimes,
  faTimesCircle,
  faTools,
  faTrashAlt,
  faTrashCanXmark,
  faTrianglePersonDigging,
  faTruckRampBox,
  faUnlink,
  faUpDownLeftRight,
  faUpload,
  faUserLarge,
  faUserPlus,
  faWandMagicSparkles,
  faXmark,
} from "@fortawesome/pro-regular-svg-icons";
import {
  faCaretDown,
  faCaretLeft,
  faCaretRight,
  faCaretUp,
  faLocationCrosshairs,
} from "@fortawesome/pro-solid-svg-icons";

import { skiliticsDuotoneIconPack } from "./customIconDefinitions.ts";

export const designerIconLibrary = () =>
  library.add(
    faAlignCenter,
    faAlignJustify,
    faAlignLeft,
    faAlignRight,
    faAngleDown,
    faAngleLeft,
    faAngleRight,
    faAngleUp,
    faAnglesDown,
    faAnglesUp,
    faArrowDownToLine,
    faArrowDownToSquare,
    faArrowLeftToLine,
    faArrowPointer,
    faArrowProgress,
    faArrowRight,
    faArrowRightArrowLeft,
    faArrowRightLong,
    faArrowRightToLine,
    faArrowRotateLeft,
    faArrowRotateRight,
    faArrowTurnUp,
    faArrowUp,
    faArrowUpRightAndArrowDownLeftFromCenter,
    faArrowUpToLine,
    faArrowsRotate,
    faBars,
    faBooks,
    faBorderAll,
    faBorderCenterH,
    faBorderCenterV,
    faBorderLeft,
    faBorderNone,
    faBorderTopLeft,
    faBox,
    faBoxOpen,
    faBroomWide,
    faBrowser,
    faBullhorn,
    faCalendarDays,
    faCaretDown,
    faCaretLeft,
    faCaretRight,
    faCaretUp,
    faCcVisa,
    faChain,
    faCheck,
    faCheckCircle,
    faCircle,
    faCircleNotch,
    faClipboard,
    faCodeBranch,
    faCog,
    faCommentsQuestion,
    faComputerMouse,
    faComputerMouseButtonLeft,
    faComputerMouseButtonRight,
    faComputerMouseScrollwheel,
    faCopy,
    faCube,
    faCubes,
    faDeleteLeft,
    faDolly,
    faDownload,
    faEllipsisH,
    faEllipsisV,
    faEllipsisVertical,
    faEnvelope,
    faEraser,
    faExclamationCircle,
    faEye,
    faEyeSlash,
    faFileAlt,
    faFileAudio,
    faFileImage,
    faFileLines,
    faFileVideo,
    faFilter,
    faFlag,
    faFolder,
    faFolderOpen,
    faFrame,
    faGear,
    faGears,
    faGift,
    faGlasses,
    faGraduationCap,
    faHandPaper,
    faHeadset,
    faHistory,
    faHouse,
    faImage,
    faIndent,
    faInfoCircle,
    faKeyboard,
    faLanguage,
    faLayerGroup,
    faLightbulb,
    faLightbulbOn,
    faLink,
    faLocationCrosshairs,
    faLock,
    faLockOpen,
    faMapPin,
    faMaximize,
    faMicrochip,
    faMinimize,
    faMinus,
    faMobileScreenButton,
    faMoon,
    faObjectGroup,
    faOutdent,
    faPalette,
    faPaperPlane,
    faPaste,
    faPenField,
    faPenToSquare,
    faPencilAlt,
    faPlay,
    faPlus,
    faQuestionCircle,
    faRectangleHistoryCirclePlus,
    faRedoAlt,
    faRetweet,
    faRightFromBracket,
    faRightLeft,
    faRotateLeft,
    faRotateRight,
    faSave,
    faScissors,
    faSearch,
    faShield,
    faSignInAlt,
    faSlidersH,
    faSpinner,
    faSpinnerThird,
    faSun,
    faSwatchbook,
    faSync,
    faTableCells,
    faTableColumns,
    faTag,
    faTimes,
    faTimesCircle,
    faTools,
    faTrashAlt,
    faTrashCanXmark,
    faTrianglePersonDigging,
    faTruckRampBox,
    faUnlink,
    faUpDownLeftRight,
    faUpload,
    faUserLarge,
    faUserPlus,
    faWandMagicSparkles,
    faXmark,
    skiliticsDuotoneIconPack,
    fak,
  );
